import React from "react";
import { MdOutlineCancel } from "react-icons/md";

const CustomChip = ({ label, value, onRemove }) => {
  return (
    <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-primary text-sm  transition-all duration-150">
      <span className="truncate max-w-[120px]">{value || label}</span>
      <button
        onClick={onRemove}
        className="text-customGreen hover:bg-primary hover:text-white rounded-full p-1 transition-all duration-150"
        aria-label={`Remove ${label}`}
      >
        <MdOutlineCancel className="text-lg" />
      </button>
    </div>
  );
};

export default CustomChip;
